export var canShowAction = function canShowAction(action, actionOptions) {
  var _actionOptions$exclud;
  if (typeof actionOptions === 'undefined') {
    return true;
  }
  if (actionOptions.hide || (_actionOptions$exclud = actionOptions.exclude) !== null && _actionOptions$exclud !== void 0 && _actionOptions$exclud.includes(action)) {
    return false;
  }
  return true;
};